import { render } from "./MemoruAlbumCard.vue?vue&type=template&id=3638ef95&ts=true"
import script from "./MemoruAlbumCard.vue?vue&type=script&lang=ts"
export * from "./MemoruAlbumCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__